const angular = require('angular')

//PS-1097: Change to trigger non-bumped PR

module.exports = angular
  .module('mw.errors', [
    require('./error-service'),
  ])
  .name
